import useSWR from "swr";
import { useCreateHeyLightAdminAxiosInstance } from "../../Auth/useCreateHeyLightAdminAxiosInstance.ts";
import { HeyLightOrderDTO } from "../../HeyLight/heyLightOrderDTO.ts";

export function useGetHeyLightOrder(orderId: string | undefined) {
  const { createAxiosInstance } = useCreateHeyLightAdminAxiosInstance();

  const { data, isLoading, error } = useSWR(
    orderId ? `/admin/orders/${orderId}` : null,
    async (url) => {
      const axiosInstance = createAxiosInstance();
      const { data } = await axiosInstance.get<HeyLightOrderDTO>(url);
      return data;
    },
  );

  return {
    order: data,
    isLoading,
    error,
  };
}
